var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        { attrs: { size: "sm" } },
        [
          _c("b-form-input", {
            attrs: {
              id: "input-location-works",
              size: "sm",
              state: _vm.state,
              disabled: this.$props.isDisabled,
              placeholder: "Вид работ объекта",
              autocomplete: "off"
            },
            on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c("b-input-group-text", [
                _vm._v("\n        " + _vm._s(_vm.getCurrentRate()) + "\n      ")
              ]),
              _vm._v(" "),
              _c("b-input-group-text", [
                _vm._v("\n        " + _vm._s(_vm.getCurrentUnit()) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    disabled: !_vm.query || this.$props.isDisabled
                  },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isFocus
            ? _c(
                "b-list-group",
                { staticClass: "autocomplete-input-location-works" },
                _vm._l(_vm.items, function(item, index) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: index,
                      attrs: { button: "" },
                      on: {
                        mousedown: function($event) {
                          return _vm.onClick(item)
                        }
                      }
                    },
                    [_c("div", {}, [_vm._v(_vm._s(_vm.getQueryName(item)))])]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33c96050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c96050","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationWorksSelect.vue
// module id = null
// module chunks = 